/**
 * Mobile drawer swipe, collection search, root icons, and desktop root keys.
 * Enhances Empire's header. Does not replace it.
 */
(function () {
  if (window.__pvNav) return;
  window.__pvNav = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  var SHAPES = {
    heart: 'M12 20 3 11C-2 4 8 0 12 7c4-7 14-3 9 4Z',
    briefcase: 'M3 7h18v14H3zM8 7V3h8v4M3 12h18M10 12v3h4v-3',
    sparkle: 'm12 2 3 7 7 3-7 3-3 7-3-7-7-3 7-3z',
    calendar: 'M4 5h16v16H4zM8 2v6M16 2v6M4 10h16M8 14h2M14 14h2',
    mug: 'M4 5h13v13c0 3-13 3-13 0ZM17 7h3c4 0 4 8-3 8M7 2v1M12 2v1',
    star: 'm12 2 3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z',
    sun: 'M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8',
    support: 'M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22M5 7h14v10H5zM5 7l7 5 7-5'
  };

  var ROOT_ICONS = {
    'Shop by Recipient': 'heart',
    'Shop by Profession': 'briefcase',
    'Shop by Interest': 'sparkle',
    'Shop by Occasion': 'calendar',
    'Shop by Product': 'mug',
    'Best Sellers': 'star',
    'New': 'sun'
  };

  var GROUP_ICONS = {
    'Family': 'heart',
    'Friends & community': 'heart',
    'Education & office': 'briefcase',
    'Healthcare & service': 'briefcase',
    'Makers & specialists': 'briefcase',
    'Hobbies & humor': 'sparkle',
    'Sports & outdoors': 'sparkle',
    'Animals, faith & support': 'sparkle',
    'Milestones & thank-yous': 'calendar',
    'Seasonal & encouragement': 'calendar'
  };

  /**
   * @param {string} name
   * @returns {string}
   */
  function icon(name) {
    var path = SHAPES[name] || SHAPES.heart;
    return '<svg class="pv-nav-icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="' + path + '"></path></svg>';
  }

  /**
   * @param {string} text
   * @returns {string}
   */
  function pluralViewAll(text) {
    var match = text.match(/^(\s*)View all (.+?)(\s*)$/);
    if (!match) return text;
    var rest = match[2];
    if (/s$/i.test(rest) || rest.indexOf('&') !== -1) return text;
    var parts = rest.split(' ');
    var last = parts[parts.length - 1];
    if (/^(new|men|women|children|people)$/i.test(last) || /s$/i.test(last)) return text;
    if (/[^aeiou]y$/i.test(last)) parts[parts.length - 1] = last.slice(0, -1) + 'ies';
    else parts[parts.length - 1] = last + 's';
    return match[1] + 'View all ' + parts.join(' ') + match[3];
  }

  function pluralizeMenu() {
    var roots = document.querySelectorAll('.site-navigation a, .site-navigation summary, .site-mobile-nav a, .site-mobile-nav summary');
    for (var i = 0; i < roots.length; i++) {
      var node = roots[i];
      for (var c = 0; c < node.childNodes.length; c++) {
        var child = node.childNodes[c];
        if (child.nodeType !== 3) continue;
        var next = pluralViewAll(child.nodeValue);
        if (next !== child.nodeValue) child.nodeValue = next;
      }
    }
  }

  function addRootIcons() {
    var links = document.querySelectorAll(
      '.site-mobile-nav .navmenu-depth-1 > .navmenu-item > a.navmenu-link,' +
      '.site-navigation .navmenu-depth-1 > .navmenu-item > a.navmenu-link,' +
      '.site-navigation .navmenu-depth-1 > .navmenu-item > details > summary.navmenu-link,' +
      '.site-navigation .navmenu-meganav-sidenav__item-text .navmenu-meganav-sidenav__submenu-wrapper > span:first-child'
    );
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.dataset.pvIcon === '1') continue;
      var label = link.textContent.replace(/\s+/g, ' ').trim();
      var name = ROOT_ICONS[label] || GROUP_ICONS[label];
      if (!name || !Object.prototype.hasOwnProperty.call(SHAPES, name)) continue;
      link.dataset.pvIcon = '1';
      link.insertAdjacentHTML('afterbegin', icon(name));
    }
  }

  function supportMarkup() {
    return '<a class="pv-nav-support" href="mailto:support@panvola.com">' +
      icon('support') +
      '<span><strong>Expert Support</strong><br>Available 24/7 via email</span></a>';
  }

  /**
   * @param {ParentNode} content
   * @returns {{label: string, href: string, url: string}[]}
   */
  function collectionLinks(content) {
    var seen = {};
    var out = [];
    var anchors = content.querySelectorAll('a.navmenu-link[href]');
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      var label = anchor.textContent.replace(/\s+/g, ' ').trim();
      var href = anchor.getAttribute('href');
      if (!label || !href || href === '#') continue;
      var key = anchor.href;
      if (seen[key]) continue;
      seen[key] = true;
      out.push({ label: label, href: href, url: anchor.href });
    }
    return out;
  }

  function mountDrawerExtras() {
    var content = document.querySelector('[data-mobile-nav-content]');
    if (!content || content.dataset.pvSearch === '1') return;
    content.dataset.pvSearch = '1';

    var search = document.createElement('search');
    search.className = 'pv-nav-search';
    search.innerHTML =
      '<label class="visually-hidden" for="pv-drawer-query">Search collections</label>' +
      '<input type="search" id="pv-drawer-query" class="pv-nav-search__input" placeholder="Search collections" autocomplete="off" enterkeyhint="search" aria-controls="pv-drawer-results">' +
      '<div class="pv-nav-search__results" id="pv-drawer-results" hidden></div>';
    content.insertBefore(search, content.firstChild);

    if (!content.querySelector('.pv-nav-support')) {
      content.insertAdjacentHTML('beforeend', supportMarkup());
    }

    var input = search.querySelector('input');
    var results = search.querySelector('.pv-nav-search__results');
    var links = collectionLinks(content);
    var menu = content.querySelector(':scope > ul.navmenu');
    var secondary = content.querySelector('.mobile-nav-content__secondary-menu');
    var border = content.querySelector('.mobile-nav-content__border');

    function setMenuHidden(hidden) {
      if (menu) menu.hidden = hidden;
      if (secondary) secondary.hidden = hidden;
      if (border) border.hidden = hidden;
    }

    function render(query) {
      var term = query.trim().toLowerCase();
      if (!term) {
        results.hidden = true;
        results.innerHTML = '';
        setMenuHidden(false);
        return;
      }
      var matches = [];
      for (var i = 0; i < links.length; i++) {
        if (links[i].label.toLowerCase().indexOf(term) !== -1) matches.push(links[i]);
      }
      var html = '<p class="pv-nav-search__count" role="status">' + matches.length +
        (matches.length === 1 ? ' collection' : ' collections') + '</p>';
      if (!matches.length) {
        html += '<p class="pv-nav-search__empty">No collections match</p>';
      } else {
        html += '<ul class="pv-nav-search__list">';
        for (var m = 0; m < matches.length; m++) {
          html += '<li><a href="' + matches[m].href.replace(/"/g, '&quot;') + '">' +
            matches[m].label.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</a></li>';
        }
        html += '</ul>';
      }
      results.innerHTML = html;
      results.hidden = false;
      setMenuHidden(true);
    }

    input.addEventListener('input', function () {
      render(input.value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!input.value && results.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      input.value = '';
      render('');
    });
  }

  function rootTriggers() {
    var list = document.querySelector('.site-navigation > ul.navmenu-depth-1');
    if (!list) return [];
    var items = list.querySelectorAll(':scope > li');
    var triggers = [];
    for (var i = 0; i < items.length; i++) {
      var trigger = items[i].querySelector(':scope > details > summary.navmenu-link, :scope > a.navmenu-link');
      if (trigger) triggers.push(trigger);
    }
    return triggers;
  }

  /**
   * @param {HTMLElement} trigger
   * @returns {HTMLElement | null}
   */
  function firstPanelLink(trigger) {
    var details = trigger.closest('details');
    if (!details) return null;
    var submenu = details.querySelector('.navmenu-submenu');
    var scope = submenu || details;
    var anchors = scope.querySelectorAll('a[href]');
    var fallback = null;
    for (var i = 0; i < anchors.length; i++) {
      var href = anchors[i].getAttribute('href');
      if (!href || href === '#') continue;
      if (!fallback) fallback = anchors[i];
      if (anchors[i].getClientRects().length) return anchors[i];
    }
    return fallback;
  }

  /**
   * Closing the root menu leaves sidenav columns display:none. Reopening the
   * root does not clear that, so the first column is opened again.
   * @param {HTMLElement} details
   */
  function revealFirstColumn(details) {
    var nested = details.querySelector('details');
    if (!nested) return;
    nested.setAttribute('open', '');
    var menus = nested.querySelectorAll('.navmenu-submenu');
    for (var i = 0; i < menus.length; i++) {
      if (menus[i].classList.contains('navmenu-meganav')) continue;
      menus[i].setAttribute('data-animation-state', 'open');
    }
  }

  /**
   * Empire's close animation removes the open attribute when it finishes.
   * That callback can land after a reopen and shut the menu again.
   * @param {HTMLElement} details
   */
  function forceRootOpen(details) {
    details.setAttribute('open', '');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    var mega = details.querySelector('.navmenu-meganav');
    if (mega) mega.setAttribute('data-animation-state', 'open');
    revealFirstColumn(details);
  }

  /**
   * @param {HTMLElement} details
   * @returns {boolean}
   */
  function panelHidden(details) {
    var sub = details.querySelector('.navmenu-submenu');
    if (!sub) return false;
    if (sub.getAttribute('data-animation-state') === 'closed') return true;
    return window.getComputedStyle(sub).display === 'none';
  }

  /**
   * Empire removes the open attribute only after the close animation, and that
   * step does not run. A hidden panel is treated as closed so Enter can open it.
   * @param {HTMLElement} trigger
   */
  var openGuard = null;

  function openRoot(trigger) {
    var details = trigger.closest('details');
    if (!details) return;
    if (details.open && panelHidden(details)) details.removeAttribute('open');
    if (!details.open) trigger.click();
    var link = firstPanelLink(trigger);
    if (!link) return;
    // Empire's close .then removes `open` a frame after this reopen and the
    // browser then drops focus to body. Keep putting the column back until
    // that one callback has landed. Escape cancels the guard.
    var token = {};
    openGuard = token;
    var tries = 0;
    function attempt() {
      if (openGuard !== token) return;
      var active = document.activeElement;
      var focusInPanel = details.contains(active) && active !== trigger;
      var dropped = !details.open || panelHidden(details) || active === document.body || active === document.documentElement;
      if (dropped || !focusInPanel) {
        forceRootOpen(details);
        var target = firstPanelLink(trigger) || link;
        if (target.getClientRects().length) target.focus();
      }
      if (tries >= 24) {
        if (openGuard === token) openGuard = null;
        return;
      }
      tries += 1;
      window.requestAnimationFrame(function () {
        if (openGuard !== token) return;
        var still = document.activeElement;
        var stable = details.open && !panelHidden(details) && details.contains(still) && still !== trigger;
        if (stable && tries > 10) {
          openGuard = null;
          return;
        }
        attempt();
      });
    }
    attempt();
  }

  function releaseStuckDetails() {
    var nodes = document.querySelectorAll('.site-navigation details[open]');
    for (var i = 0; i < nodes.length; i++) {
      var details = nodes[i];
      if (!panelHidden(details)) continue;
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }

  function bindDesktopKeys() {
    var nav = document.querySelector('.site-navigation');
    if (!nav || nav.dataset.pvKeys === '1') return;
    nav.dataset.pvKeys = '1';

    nav.addEventListener('keydown', function (event) {
      var triggers = rootTriggers();
      var index = triggers.indexOf(event.target);
      if (index === -1) return;
      var trigger = triggers[index];
      var key = event.key;

      if (key === 'ArrowRight' || key === 'ArrowLeft' || key === 'Home' || key === 'End') {
        event.preventDefault();
        var next = index;
        if (key === 'ArrowRight') next = (index + 1) % triggers.length;
        else if (key === 'ArrowLeft') next = (index - 1 + triggers.length) % triggers.length;
        else if (key === 'Home') next = 0;
        else next = triggers.length - 1;
        triggers[next].focus();
        return;
      }

      if (key === 'ArrowDown' || key === 'Enter' || key === ' ') {
        if (!trigger.closest('details')) return;
        event.preventDefault();
        openRoot(trigger);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      openGuard = null;
      window.setTimeout(releaseStuckDetails, 500);
    });
  }

  function bindSwipe() {
    var nav = document.querySelector('[data-mobile-nav]');
    var panel = document.querySelector('[data-mobile-nav-panel]');
    if (!nav || !panel || panel.dataset.pvSwipe === '1') return;
    panel.dataset.pvSwipe = '1';

    var drag = null;
    var suppressClick = false;

    function clearDragStyle() {
      panel.classList.remove('pv-nav-dragging');
      panel.style.transform = '';
      panel.style.transition = '';
    }

    function closeDrawer() {
      var closer = document.querySelector('[data-mobile-nav-close]');
      if (closer) closer.click();
    }

    function finishClose() {
      closeDrawer();
      var tries = 0;
      function release() {
        var state = panel.getAttribute('data-animation-state') || '';
        var open = nav.getAttribute('data-open');
        if (open === 'false' || state === 'closed' || tries > 30) {
          clearDragStyle();
          return;
        }
        tries += 1;
        window.setTimeout(release, 50);
      }
      release();
    }

    function springBack() {
      if (reduced.matches) {
        clearDragStyle();
        return;
      }
      panel.style.transition = 'transform 280ms cubic-bezier(0.2, 0.8, 0.2, 1)';
      panel.style.transform = 'translateX(0px)';
      panel.addEventListener('transitionend', function done() {
        clearDragStyle();
      }, { once: true });
    }

    panel.addEventListener('pointerdown', function (event) {
      if (nav.getAttribute('data-open') !== 'true') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('input, textarea, select, .pv-nav-search')) return;
      drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        dx: 0,
        locked: '',
        samples: [{ x: event.clientX, t: performance.now() }]
      };
    });

    panel.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x;
      var dy = event.clientY - drag.y;
      if (!drag.locked) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        drag.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (drag.locked !== 'x') return;
      if (dx > 0) dx = 0;
      event.preventDefault();
      drag.dx = dx;
      drag.samples.push({ x: event.clientX, t: performance.now() });
      if (drag.samples.length > 8) drag.samples.shift();
      panel.classList.add('pv-nav-dragging');
      panel.style.transition = 'none';
      panel.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: false });

    function endDrag(event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = drag.dx;
      var locked = drag.locked;
      var samples = drag.samples;
      drag = null;
      if (locked !== 'x') return;
      if (dx < -10) suppressClick = true;

      var now = performance.now();
      var origin = samples[0];
      for (var i = samples.length - 1; i >= 0; i--) {
        if (now - samples[i].t >= 40) {
          origin = samples[i];
          break;
        }
      }
      var elapsed = Math.max(16, now - origin.t);
      var velocity = (samples[samples.length - 1].x - origin.x) / elapsed;
      var flick = velocity < -0.12 && dx <= -24;
      var far = dx <= -80;
      panel.dataset.pvSwipeDx = String(Math.round(dx));
      panel.dataset.pvSwipeVx = String(Math.round(velocity * 1000) / 1000);

      if (flick || far) {
        if (reduced.matches) {
          finishClose();
          return;
        }
        panel.style.transition = 'transform 220ms cubic-bezier(0.4, 0, 1, 1)';
        panel.style.transform = 'translateX(-100%)';
        var closed = false;
        function done() {
          if (closed) return;
          closed = true;
          finishClose();
        }
        panel.addEventListener('transitionend', done, { once: true });
        window.setTimeout(done, 320);
        return;
      }
      springBack();
    }

    panel.addEventListener('pointerup', endDrag);
    panel.addEventListener('pointercancel', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      drag = null;
      springBack();
    });

    panel.addEventListener('click', function (event) {
      if (!suppressClick || !event.isTrusted) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function start() {
    pluralizeMenu();
    addRootIcons();
    mountDrawerExtras();
    bindDesktopKeys();
    bindSwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
